import style from './menu-main.scss';
import mainMenu from "Assets/js/main-menu-behavior";

const script = () => {

  mainMenu({
    cssSelector: '.menu--main',
    itemTriggerSelector: '.menu--main .menu-item--expanded > span, .menu-item--expanded > a',
    linkActiveSelector: '.menu--main .menu-item .menu-item > a.is-active',
  });

};

export {
  style,
  script,
};
